// Generate Organization Schema
export const getOrganizationSchema = () => {
  const baseUrl = window.location.origin;
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "FinanciallyFree.ro",
    "url": baseUrl,
    "logo": `${baseUrl}/logo.png`,
    "description": "Platformă românească pentru libertate financiară, educație financiară și side hustle-uri",
    "sameAs": [
      "https://instagram.com/financiallyfree.official",
      "https://tiktok.com/@financiallyfree.official"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Support",
      "email": "contact@financiallyfree.ro"
    }
  };
};

// Generate WebSite Schema
export const getWebSiteSchema = () => {
  const baseUrl = window.location.origin;
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "FinanciallyFree.ro",
    "url": baseUrl,
    "description": "Învață să economisești, să investești și să construiești side hustle-uri profitabile",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${baseUrl}/blog?search={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };
};

// Generate Article Schema for Blog Posts
export const getArticleSchema = (post) => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "description": post.subtitle || post.seo_meta_description,
    "image": post.image_url || `${baseUrl}/og-image.jpg`,
    "author": {
      "@type": "Person",
      "name": post.author || "Andrei"
    },
    "publisher": {
      "@type": "Organization",
      "name": "FinanciallyFree.ro",
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/logo.png`
      }
    },
    "datePublished": post.published_date,
    "dateModified": post.published_date,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `${baseUrl}/blog/${post.slug}`
    },
    "keywords": post.seo_meta_description,
    "articleSection": post.category,
    "inLanguage": post.language === 'ro' ? 'ro-RO' : 'en-US'
  };
};

// Generate Product Schema
export const getProductSchema = (product) => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": product.title,
    "description": product.description,
    "image": product.image || `${baseUrl}/og-image.jpg`,
    "brand": {
      "@type": "Brand",
      "name": "FinanciallyFree.ro"
    },
    "offers": {
      "@type": "Offer",
      "url": product.link,
      "priceCurrency": "EUR",
      "price": product.price,
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "FinanciallyFree.ro"
      }
    }
  };
};

// Generate BreadcrumbList Schema
export const getBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

// Generate FAQ Schema
export const getFAQSchema = (faqs) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};
